import { render, staticRenderFns } from "./PriceTrendChart.vue?vue&type=template&id=101edd36&"
import script from "./PriceTrendChart.vue?vue&type=script&lang=js&"
export * from "./PriceTrendChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports